var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "restart_alt"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_223_22942",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    y: 0.901733,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_223_22942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "restart_alt_2",
    d: "M9.66671 18.3601C7.98615 18.1517 6.59379 17.4191 5.48962 16.1622C4.38546 14.9052 3.83337 13.4295 3.83337 11.7351C3.83337 10.8184 4.01393 9.93994 4.37504 9.09966C4.73615 8.25938 5.25004 7.52674 5.91671 6.90174L7.10421 8.08924C6.57643 8.56147 6.17712 9.11008 5.90629 9.73508C5.63546 10.3601 5.50004 11.0267 5.50004 11.7351C5.50004 12.9573 5.88893 14.0372 6.66671 14.9747C7.44449 15.9122 8.44449 16.4851 9.66671 16.6934V18.3601ZM11.3334 18.3601V16.6934C12.5417 16.4712 13.5382 15.8948 14.323 14.9642C15.1077 14.0337 15.5 12.9573 15.5 11.7351C15.5 10.3462 15.0139 9.16563 14.0417 8.19341C13.0695 7.22119 11.8889 6.73508 10.5 6.73508H10.4375L11.3542 7.65174L10.1875 8.81841L7.27087 5.90174L10.1875 2.98508L11.3542 4.15174L10.4375 5.06841H10.5C12.3612 5.06841 13.9375 5.71424 15.2292 7.00591C16.5209 8.29758 17.1667 9.87397 17.1667 11.7351C17.1667 13.4156 16.6146 14.8844 15.5105 16.1413C14.4063 17.3983 13.0139 18.1379 11.3334 18.3601Z",
    fill: "#1C1B1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/Restart.1a5d0ee1708ae9b9384ed205a9b40951.svg";
export { ForwardRef as ReactComponent };